import { Check } from "lucide-react";

const stepNames = ["Product", "Layout", "Dimensions", "Material", "Mounting", "Features", "Review", "Contact"];

function getStepIndicatorClass(done, active) {
  if (done) return "bg-[#FF5722] text-white";
  if (active) return "bg-[#FF5722] text-white ring-2 ring-[#FF5722]/30 ring-offset-2 ring-offset-[#0A0A0A]";
  return "bg-[#1F1F1F] text-[#666] border border-[#2E2E2E]";
}

function getStepLabelClass(done, active) {
  if (active) return "text-[#FF5722]";
  if (done) return "text-white";
  return "text-[#666]";
}

export default function ProgressBar({ currentStep }) {
  return (
    <div data-testid="quote-progress-bar" className="w-full">
      {/* Desktop */}
      <div className="hidden sm:flex items-center justify-between">
        {stepNames.map((name, i) => {
          const stepNum = i + 1;
          const done = currentStep > stepNum;
          const active = currentStep === stepNum;
          return (
            <div key={name} className="flex items-center flex-1 last:flex-none">
              <div className="flex flex-col items-center">
                <div className={`w-8 h-8 flex items-center justify-center text-[10px] font-bold transition-all duration-300 ${getStepIndicatorClass(done, active)}`}>
                  {done ? <Check size={12} /> : stepNum}
                </div>
                <span className={`mt-2 text-[9px] font-medium tracking-wide uppercase ${getStepLabelClass(done, active)}`}>
                  {name}
                </span>
              </div>
              {i < stepNames.length - 1 && (
                <div className={`flex-1 h-px mx-2 mt-[-18px] ${done ? "bg-[#FF5722]" : "bg-[#2E2E2E]"}`} />
              )}
            </div>
          );
        })}
      </div>
      {/* Mobile */}
      <div className="sm:hidden">
        <div className="flex items-center justify-between mb-2">
          <span className="text-[#FF5722] text-xs font-semibold uppercase tracking-wider">
            Step {currentStep} of {stepNames.length}
          </span>
          <span className="text-white text-xs font-bold">{stepNames[currentStep - 1]}</span>
        </div>
        <div className="w-full h-1 bg-[#1F1F1F]">
          <div
            className="h-full bg-[#FF5722] transition-all duration-500"
            style={{ width: `${(currentStep / stepNames.length) * 100}%` }}
          />
        </div>
      </div>
    </div>
  );
}
